// removed by extract-text-webpack-plugin
module.exports = {"box":"_1GrJESUT_rSKLabvf3Y-QH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/ExperienceFinished/style.module.css
// module id = 515
// module chunks = 39